import 'leaflet';
import 'leaflet.awesome-markers'
import 'leaflet.tilelayer.colorfilter'

export default class MapListener {
    constructor() {
        const {__} = wp.i18n;

        document.addEventListener("DOMContentLoaded", () => {
            let mapContainer = document.querySelector('.leaflet-map');

            if (mapContainer) {

                let zoom = 14;
                if (L.Browser.mobile === true) {
                    zoom = 12;
                }

                let latitude = mapContainer.getAttribute('data-map-latitude');
                let longitude = mapContainer.getAttribute('data-map-longitude');
                let googleMapsUrl = mapContainer.getAttribute('data-map-google-maps-url');

                let map = L.map(mapContainer.getAttribute('id'), {
                    dragging: !L.Browser.mobile,
                    tap: !L.Browser.mobile
                }).setView([latitude, longitude], zoom);

                L.tileLayer.colorFilter('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
                //     filter: ['grayscale:100%'],
                }).addTo(map);

                let leafletMarker = L.AwesomeMarkers.icon({
                    icon: 'icon-globsk',
                    prefix: 'icon',
                    spin: false,
                    extraClasses: 'rwn-icon text-first display-4'
                });

                L.marker([latitude, longitude], {
                    icon: leafletMarker
                }).addTo(map);

                if (googleMapsUrl.length > 0) {
                    let googleBtn = L.Control.extend({
                        options: {
                            position: 'bottomright'
                        },
                        onAdd: function (map) {
                            let container = L.DomUtil.create('div', 'leaflet-bar leaflet-control');
                            let button = L.DomUtil.create('a', 'leaflet-control-button w-auto px-3', container);
                            button.text = __('Open in Google Maps', 'rwn');
                            button.href = googleMapsUrl;
                            button.target = '_blank';

                            return container;
                        }
                    });
                    map.addControl(new googleBtn());
                }
            }
        });
    }
}